// Os dois modos de um alvo da EAP no editor de desembolso (design D20): o cronograma novo (a
// regra, que redistribui o valor global) e o ajuste pontual mês a mês sobre a referência.
// Módulo à parte para quem abre o editor não depender do componente para o vocabulário.
export const EDITOR_MODES = Object.freeze({
  schedule: "schedule",
  monthEdit: "month_edit",
});
